module.exports = __webpack_public_path__ + "assets/media/chrome-notif.5ae38065.png";